// MultipleSkeletonComponent.jsx
import React from 'react';
import { Avatar, Box, Card, Grid, Skeleton, Typography } from '@mui/material';

export const sidebarSkeleton = () => {
    return (
        <Box>
            {[1, 2, 3, 4].map(d => (<Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ margin: 1 }}>
                    <Skeleton variant="circular">
                        <Avatar />
                    </Skeleton>
                </Box>
                <Box sx={{ width: '100%' }}>
                    <Skeleton width="100%">
                        <Typography>.</Typography>
                    </Skeleton>
                </Box>
            </Box>))}
        </Box>
    )
};


export const notificatioSettingSkeleton = () => {
    return (
        <Box>
            {[1, 2, 3, 4, 5, 6, 7].map(d => (<Box sx={{ display: 'flex', alignItems: 'center', margin:'20px 0px' }}>
                <Box sx={{ margin: 1 }}>
                    <Skeleton width={20} height={20} variant="square">
                        <Avatar />
                    </Skeleton>
                </Box>
                <Box sx={{ width: '80%' }}>
                    <Skeleton width="20%">
                        <Typography>.</Typography>
                    </Skeleton>
                    <Skeleton width="100%">
                        <Typography>.</Typography>
                    </Skeleton>
                </Box>
                <Box sx={{ width: '20%' }} display={'flex'} justifyContent={'end'}>
                    <Skeleton width="30%">
                        <Typography>.</Typography>
                    </Skeleton>
                </Box>
            </Box>))}
        </Box>
    )
};


export const moreActionSkeleton = () => {
    return (
        <Grid container spacing={2}>
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(d => (<Grid key={d} item xs={6} sm={4} md={3} lg={2}>
                <Card >
                    <Skeleton variant="circular" width={40} height={40} />
                    <Skeleton animation="wave" height={20} weight={10} />
                </Card>
            </Grid>
            ))}
        </Grid>
    )
};
